import { createTheme } from '@mui/material/styles';

// Values must match the CSS variables defined in app.scss
const muiTheme = createTheme({
    palette: {
        primary: {
            main: '#2ab7af', // --brand-primary
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#6b7280',
        },
        success: {
            main: '#00b07f', // --appGreen
            contrastText: '#ffffff',
        },
        error: {
            main: '#dc3545', // --danger-color
        },
        info: {
            main: '#667eea', // --info-color
        },
        warning: {
            main: '#ffc107', // --warning-color
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    '&:active': {
                        boxShadow: 'none',
                    },
                },
            },
        },
    },
});

export default muiTheme;
